<uc-info-clearing-toggle
	[product]="product()"
	[copy]="infoClearingToggle"
	(clearingChange)="studyLevelChange.emit($event)"
/>

<!-- related subjects -->
@if (relatedSubjects() && relatedSubjects()?.length) {
	<uc-subjects-carousel>
		@for (item of relatedSubjects(); track $index) {
			<uc-related-subject
				[label]="item.name"
				[count]="item.course_count"
				[degreeLevel]="degreeLevel()"
				(relatedSubject)="onRelatedSubject($event)"
			/>
		}
	</uc-subjects-carousel>
}

<!-- back to general search -->
@if (showIndividualUniCourses()) {
	<uc-back-to-all-courses-btn [ngClass]="{ 'block mt-8': clearingEnabled }" />
}

<!-- course cards -->
<ng-content />

<!-- no result -->
@if (resultLength() === 0) {
	<uc-course-search-no-result
		[searchTerm]="searchTerm()"
		[type]="type()"
		class="block mt-8"
	/>
}
